import { animate, group, query, stagger, style, transition, trigger } from '@angular/animations';

export const groupStaggerDown = trigger('groupStaggerDownAnimation', [
    transition('* => *', [
        query(
            ':enter',
            [
                style({
                    opacity: 0,
                    transform: 'translateY(-10%)',
                }),
                stagger(50, [
                    group([animate(400, style({ opacity: 1 })), animate(200, style({ transform: 'translateY(0)' }))]),
                ]),
            ],
            { optional: true },
        ),

        query(
            ':leave',
            [
                style({ opacity: 1 }),
                stagger(0, [
                    group([animate(250, style({ opacity: 0 })), animate(250, style({ height: 0, minHeight: 0 }))]),
                ]),
            ],
            { optional: true },
        ),
    ]),
]);
